var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.packages),function(p){return _c('div',[_c('a',{attrs:{"href":_vm.link(p)},domProps:{"textContent":_vm._s(p.name)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }